<template>
    <v-dialog v-model="dialog" width="35vw">
        <v-card>
            <v-card-title>Download and send billings for a selected period
            </v-card-title>      
            <v-card-text>
                <v-row no-gutters>
                    <v-col cols="12" class="my-4">
                        <v-text-field 
                            v-model="sendto_email"
                            label="Send to"
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" class="mb-4">
                        <v-select
                            v-model="selectedAccommodations"
                            :items="accommodationSelectItems"
                            label="Select accommodations *"
                            multiple
                            dense
                            chips
                            small-chips
                            deletable-chips
                        >
                            <template v-slot:prepend-item>
                                <v-list-item ripple @click="toggleSelectAll">
                                    <v-list-item-action>
                                        <v-icon :color="selectedAccommodations.length > 0 ? 'indigo darken-4' : ''">
                                            {{ selectAllIcon }}
                                        </v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>Select All</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index < 3" small>
                                    <span>{{ item.text }}</span>
                                </v-chip>
                                <span v-if="index === 3" class="grey--text text-caption">
                                    (+{{ selectedAccommodations.length - 3 }} others)
                                </span>
                            </template>
                        </v-select>
                    </v-col>
                </v-row>    
                <v-row no-gutters  align="center">
                    <v-col cols="4">
                        <v-menu
                            ref="menu1"
                            v-model="menu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="date_from_display"
                                    label="From"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    dense
                                ></v-text-field>
                            </template>
                            <v-date-picker 
                                v-model="date_from" 
                                @input="menu1 = false"
                                :first-day-of-week="1"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="4" offset="1">
                        <v-menu
                            ref="menu2"
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="date_to_display"
                                    label="To"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    dense
                                ></v-text-field>
                            </template>
                            <v-date-picker 
                                v-model="date_to" 
                                @input="menu2 = false"
                                :first-day-of-week="1"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>

                <v-row no-gutters class="mt-4">
                    <v-col cols="12">
                        <v-textarea
                            v-model="mailtext"
                            placeholder="Click here and add any additional text to include in the email..."
                            persistent-placeholder
                            dense
                            rows="5"
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-card-text>         
            <v-card-actions>
                <v-alert dense text type="error" class="mb-2 ml-2 mr-2 flex-grow-1" style="min-height: 36px;" :style="{ visibility: errorMessage ? 'visible' : 'hidden' }">
                    {{ errorMessage || '&nbsp;' }}
                </v-alert>
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="close" class="mb-2">Close</v-btn>
                <v-btn color="primary" v-bind:disabled="loading" v-bind:loading="loading" v-on:click="sendBillings()" small class="mb-2">
                    <v-icon left>mdi-email-fast-outline</v-icon>Send billings
                    <template v-slot:loader>
                        <span class="custom-loader">
                            <v-icon light>mdi-cached</v-icon>
                        </span>
                    </template>
                </v-btn>            
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    export default {
        props: {
            eign_encrid: String, eign_email: String, items: Array, eign_code: String
        },     
        mounted(){
        },   
        components: {
        },      
        data() {
            return {
                dialog: false,
                loading: false,
                date_from: null,
                date_to: null,
                menu1: false,
                menu2: false,
                errorMessage: '',
                mailtext: '',
                selectedAccommodations: [],
                sendto_email: '',
            }
        },
        computed: {
            date_from_display() {
                if (!this.date_from) return '';
                const [year, month, day] = this.date_from.split('-');
                return `${day}/${month}/${year}`;
            },
            date_to_display() {
                if (!this.date_to) return '';
                const [year, month, day] = this.date_to.split('-');
                return `${day}/${month}/${year}`;
            },
            homeownerAccommodations() {
                if (!this.items || !Array.isArray(this.items)) return [];
                
                // Filter for homeowner role - check in contacts array that eign_code matches and role is homeowner
                const filtered = this.items.filter(item => {
                    if (!item.contacts || !Array.isArray(item.contacts)) return false;
                    // Check if any contact has homeowner role AND matches the eign_code
                    const hasMatchingHomeowner = item.contacts.some(contact => {
                        if (!contact.hsct_rol || !contact.eign_code) return false;
                        const isHomeowner = contact.hsct_rol.toLowerCase().includes('homeowner');
                        const isMatchingEign = contact.eign_code === this.eign_code;
                        return isHomeowner && isMatchingEign;
                    });
                    return hasMatchingHomeowner;
                });
                return filtered;
            },
            accommodationSelectItems() {
                return this.homeownerAccommodations.map(item => ({
                    text: `${item.huis_code} ${item.huis_naam}`,
                    value: item.huis_code
                }));
            },
            selectAllIcon() {
                if (this.allSelected) return 'mdi-close-box';
                if (this.someSelected) return 'mdi-minus-box';
                return 'mdi-checkbox-blank-outline';
            },
            allSelected() {
                return this.selectedAccommodations.length === this.homeownerAccommodations.length && this.homeownerAccommodations.length > 0;
            },
            someSelected() {
                return this.selectedAccommodations.length > 0 && !this.allSelected;
            },
            selectedAccommodationsString() {
                if (this.allSelected) {
                    return 'all';
                }
                return this.selectedAccommodations.join(',');
            }
        },
        watch: {
            homeownerAccommodations: {
                handler(newVal) {
                    if (newVal && newVal.length > 0 && this.selectedAccommodations.length === 0) {
                        this.selectedAccommodations = newVal.map(item => item.huis_code);
                    }
                },
                immediate: true
            }
        },
        methods: {
            open() {
                // Clear all form fields
                this.date_from = null;
                this.date_to = null;
                this.errorMessage = '';
                this.mailtext = '';
                this.selectedAccommodations = [];
                this.sendto_email = this.eign_email || '';
                
                this.dialog = true;
                // Select all accommodations by default
                this.$nextTick(() => {
                    if (this.homeownerAccommodations.length > 0) {
                        this.selectedAccommodations = this.homeownerAccommodations.map(item => item.huis_code);
                    }
                });
            },
            close() {
                this.dialog = false;
                this.errorMessage = '';
            },
            toggleSelectAll() {
                this.$nextTick(() => {
                    if (this.allSelected) {
                        this.selectedAccommodations = [];
                    } else {
                        this.selectedAccommodations = this.homeownerAccommodations.map(item => item.huis_code);
                    }
                });
            },
            showError(message) {
                this.errorMessage = message;
                setTimeout(() => {
                    this.errorMessage = '';
                }, 3000);
            },
            validateForm() {
                // Email validation regex (RFC 5322 compliant)
                const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
                
                // Check if email is valid
                if (!this.sendto_email || !this.sendto_email.trim()) {
                    this.showError('Please enter an email address');
                    return false;
                }
                
                if (!emailRegex.test(this.sendto_email.trim())) {
                    this.showError('Please enter a valid email address');
                    return false;
                }
                
                // Check if from date is filled out
                if (!this.date_from) {
                    this.showError('Please select a "From" date');
                    return false;
                }
                
                // Check if to date is filled out
                if (!this.date_to) {
                    this.showError('Please select a "To" date');
                    return false;
                }
                
                // Check if from date is before or equal to to date
                if (new Date(this.date_from) > new Date(this.date_to)) {
                    this.showError('"From" date must be before or equal to "To" date');
                    return false;
                }
                
                // Check if mail text is filled out
                if (!this.mailtext || !this.mailtext.trim()) {
                    this.showError('Please enter additional message text');
                    return false;
                }
                
                // Check if at least one accommodation is selected
                if (!this.selectedAccommodations || this.selectedAccommodations.length === 0) {
                    this.showError('Please select at least one accommodation');
                    return false;
                }
                
                return true;
            },
            sendBillings() {
                // Validate form before sending
                if (!this.validateForm()) {
                    return;
                }
                
                // Logic to send the invitation
                this.loading = true
                this.$axios
                .post("ares/json/ares/eign/sendBulkBillingsMail.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "sendBulkBillingsMail"
                    },
                    sendBulkBillingsMail: {
                        eign_encrid: this.eign_encrid,
                        date_from: this.date_from,
                        date_to: this.date_to,
                        email: this.sendto_email,
                        mailtext: this.mailtext,
                        accommodations: this.selectedAccommodationsString
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.loading = false
                    } else {
                        this.loading = false
                        this.close(); // clear any ongoing updates
                    }
                })                      
            }
        }
    }
</script>

<style scoped>
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }
    @-moz-keyframes loader {
        from {transform: rotate(0);}
        to {transform: rotate(360deg);}
    }
    @-webkit-keyframes loader {
        from {transform: rotate(0);}
        to {transform: rotate(360deg);}
    }
    @-o-keyframes loader {
        from {transform: rotate(0);}
        to {transform: rotate(360deg);}
    }
    @keyframes loader {
        from {transform: rotate(0);}
        to {transform: rotate(360deg);}
    } 

</style>